// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-first[data-v-b1e7e08c]{padding-top:127px;padding-bottom:251px;text-align:center}.login-first p[data-v-b1e7e08c]{font-size:16px;color:#666;line-height:25px;margin-top:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
